export interface ArticleCard {
  slug: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  readTime: string;
  category: string;
  date: string;
}

export const articles: ArticleCard[] = [
  {
    slug: 'oopbuy-spreadsheet-versand-guide',
    title: 'OOPBuy Spreadsheet Versand Guide 2026 – So sparst du bis zu 40%',
    excerpt: 'Erfahre alles über DHL, UPS, EMS und EUB Versandoptionen mit dem OOPBuy Spreadsheet. Detaillierte Kostenvergleiche und Profitipps für Deutschland.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20on%20light%20beige%20desk%20with%20packing%20tape%20and%20label%20printer%20soft%20natural%20window%20light%20clean%20workspace%20product%20photography&width=800&height=500&seq=article-card-versand&orientation=landscape',
    readTime: '8 Min.',
    category: 'Versand',
    date: '12. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-qc-checkliste',
    title: 'OOPBuy Spreadsheet QC Checkliste – Jeden Fehler sofort erkennen',
    excerpt: 'Die komplette QC-Checkliste für alle Produktkategorien im OOPBuy Spreadsheet. Lerne professionelle Qualitätskontrolle in 5 Minuten.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20fabric%20details%20on%20clean%20white%20tabletop%20with%20soft%20diffused%20studio%20light%20minimalist%20inspection%20product%20photography&width=800&height=500&seq=article-card-qc&orientation=landscape',
    readTime: '10 Min.',
    category: 'QC Guide',
    date: '10. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-sicherheit',
    title: 'OOPBuy Spreadsheet Sicherheit – 100% geschützt einkaufen 2026',
    excerpt: 'So kaufst du mit dem OOPBuy Spreadsheet absolut sicher ein. PayPal-Schutz, verifizierte Verkäufer und die besten Sicherheits-Tipps.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Padlock%20and%20shield%20symbols%20on%20light%20cream%20desk%20surface%20with%20soft%20natural%20lighting%20modern%20cybersecurity%20concept%20clean%20minimalist%20product%20photography&width=800&height=500&seq=article-card-safety&orientation=landscape',
    readTime: '7 Min.',
    category: 'Sicherheit',
    date: '8. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-anfaenger',
    title: 'OOPBuy Spreadsheet für Anfänger – Deine erste Bestellung 2026',
    excerpt: 'Nie bei OOPBuy bestellt? Mit dem Spreadsheet und dieser Schritt-für-Schritt-Anleitung klappt deine erste Bestellung garantiert.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20checklist%20next%20to%20laptop%20on%20warm%20beige%20desk%20surface%20soft%20morning%20light%20beginner%20workspace%20product%20photography&width=800&height=500&seq=article-card-beginner&orientation=landscape',
    readTime: '9 Min.',
    category: 'Anfänger',
    date: '6. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-sneaker-guide',
    title: 'OOPBuy Spreadsheet Sneaker Guide – Die besten Schuhe finden',
    excerpt: 'Vom Nike Dunk bis zum Jordan 4: Unser Sneaker-Guide im OOPBuy Spreadsheet zeigt dir die besten Modelle und Verkäufer für 2026.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20white%20sneakers%20on%20light%20neutral%20surface%20with%20soft%20angled%20lighting%20clean%20editorial%20product%20photography%20minimalist%20footwear%20display&width=800&height=500&seq=article-card-sneaker&orientation=landscape',
    readTime: '11 Min.',
    category: 'Sneakers',
    date: '4. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-verkaufer-bewertung',
    title: 'OOPBuy Spreadsheet Verkäufer Guide – Nur die Besten auswählen',
    excerpt: 'Wie du mit dem OOPBuy Spreadsheet die besten Verkäufer identifizierst. Bewertungen richtig lesen und Fake-Verkäufer sofort erkennen.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Star%20rating%20icons%20and%20product%20cards%20on%20clean%20light%20surface%20with%20soft%20even%20studio%20lighting%20minimal%20review%20concept%20product%20photography&width=800&height=500&seq=article-card-seller&orientation=landscape',
    readTime: '8 Min.',
    category: 'Verkäufer',
    date: '2. Juli 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-zoll-deutschland',
    title: 'OOPBuy Spreadsheet Zoll Guide – Keine bösen Überraschungen',
    excerpt: 'Alles über Zoll, Einfuhrumsatzsteuer und Freigrenzen beim OOPBuy-Einkauf nach Deutschland. Mit dem Spreadsheet immer den Überblick behalten.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Customs%20declaration%20forms%20and%20calculator%20on%20light%20beige%20desk%20surface%20with%20soft%20natural%20light%20professional%20clean%20document%20product%20photography&width=800&height=500&seq=article-card-customs&orientation=landscape',
    readTime: '9 Min.',
    category: 'Zoll',
    date: '30. Juni 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-hoodie-jacket-guide',
    title: 'OOPBuy Spreadsheet Hoodie & Jacken Guide – Streetwear Trends 2026',
    excerpt: 'Die besten Hoodies und Jacken im OOPBuy Spreadsheet. Von Essentials bis Balenciaga – finde die angesagtesten Streetwear-Pieces.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20hoodie%20folded%20on%20light%20neutral%20surface%20with%20soft%20diffused%20lighting%20clean%20minimalist%20streetwear%20product%20photography%20aesthetic&width=800&height=500&seq=article-card-hoodie&orientation=landscape',
    readTime: '10 Min.',
    category: 'Streetwear',
    date: '28. Juni 2026',
  },
  {
    slug: 'oopbuy-spreadsheet-preisvergleich',
    title: 'OOPBuy Spreadsheet Preisvergleich – Maximal sparen bei jedem Kauf',
    excerpt: 'Vergleiche Preise, Versandkosten und Verkäufer mit dem OOPBuy Spreadsheet. So sparst du bei jedem Einkauf bares Geld in 2026.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Price%20tags%20and%20calculator%20on%20light%20cream%20surface%20with%20soft%20natural%20lighting%20modern%20minimalist%20price%20comparison%20concept%20product%20photography&width=800&height=500&seq=article-card-price&orientation=landscape',
    readTime: '7 Min.',
    category: 'Sparen',
    date: '26. Juni 2026',
  },
];